import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import type { TimeRangeOption } from '../config/plotTypes';
import { TimeRangePill } from './TimeRangePill';

const defaultOptions: TimeRangeOption[] = [
  { quantity: 1, unit: 'minute' },
  { quantity: 1, unit: 'hour' },
  { quantity: 1, unit: 'day' },
  { quantity: 1, unit: 'week' },
  { quantity: 1, unit: 'month' },
  { quantity: 1, unit: 'year' },
];

const optionKey = (option: TimeRangeOption): string =>
  `${option.quantity}:${option.unit}`;

export interface TimeRangePillSetProps {
  initialSelected: TimeRangeOption | null;
  units?: TimeRangeOption[];
  onSelect: (option: TimeRangeOption) => void;
}

export const TimeRangePillSet: React.FC<TimeRangePillSetProps> = ({
  initialSelected,
  units = defaultOptions,
  onSelect,
}) => {
  const [selected, setSelected] = useState<TimeRangeOption | null>(
    initialSelected
  );

  useEffect(() => {
    setSelected(initialSelected);
  }, [initialSelected]);

  const handleSelect = (option: TimeRangeOption) => {
    setSelected(option);
    onSelect(option);
  };

  return (
    <Box display="flex" gap={1}>
      {units.map((option) => (
        <TimeRangePill
          key={optionKey(option)}
          option={option}
          onSelect={handleSelect}
          isSelected={
            selected !== null && optionKey(selected) === optionKey(option)
          }
        />
      ))}
    </Box>
  );
};
